module.exports = __webpack_public_path__ + "img/diet-low-carb.93cf1fc7.png";